module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACYAAAAYCAYAAAHhSr/lAAAAAXNSR0IArs4c6QAAAVNJREFUSA1jfK2g/p8BDTCh8cFcrIKMIO0i928wvFHUgGvCqhKrIFg7TB+6MTBxEM34HwiQBXCxiTcR5nGQte9snBn+PX2KYShWR6OrIkoRUR6AO55iN8FNQnYsyFQQwOVbZLXIbKI8iKwBH5uogMBnALIc44fYJIxkwb9oLljN56Iyhn9v3iKrx8tm+X34KE4Fv0+dxZpCcGmgbpjB0irMNu6mOgbO2CgwFznnweTx0VR12QgxjKqJlqphhpEDOOKiGdhdnMAp4GNcMr6UgCGHkQPYXJ3hivDlDrgiJAZVvTl4DcNa0iIFA5iJnF9hcqSWwjB9xNJUDTJiLSVG3ajDiAklZDUsnNkZyHysbBYdbQxxjvhohv8fP2GIU0uAquUitRwFMmfQprHR4oLUaB60UTloHcbCyMhwmmAwf/ok8ffWbUFkdYwM/+4A9f5GFqMmGwAW2H00DRMqtgAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/Danmark.png
// module id = 467
// module chunks = 7